import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { FormGroup, ReactiveFormsModule } from '@angular/forms'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { VehicleModelService } from '../../../../core/services/vehicle/vehicle-model/vehicle-model.service'
import { VehicleTypeService } from '../../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import { MatProgressBar } from '@angular/material/progress-bar'
import { MatPaginator, PageEvent } from '@angular/material/paginator'
import { PagedContactTypeResponse } from '../../../../core/models/contact-type.model'
import { PurchasesQuoteRequestService } from '../../../../core/services/purchases/purchases-quote-request/purchases-quote-request.service'
import { TableListSelectPurchasesComponent } from '../../../../shared/components/table-list-select-purchases/table-list-select-purchases.component'
import { SupplierService } from '../../../../core/services/person/supplier/supplier.service'
import { ModalPurchasesRequestItinerariesComponent } from '../modal-purchases-request-itineraries/modal-purchases-request-itineraries.component'
import { MatExpansionModule } from '@angular/material/expansion'
import { FormClientSearchComponent } from '../../../../shared/components/form-client-search/form-search.component'
import { responseDefaultForm } from '../../../../shared/utils/utils'
import { SupplierCreateComponent } from '../../../person/supplier/supplier-create/supplier-create.component'
import { DialogChooseComponent } from '../../../../shared/components/dialog-to-choose/dialog-to-choose.component'
import { FormSearchQuoteRequestTgComponent } from '../../../../shared/components/form-search-quote-request-tg/form-search-quote-request-tg.component'
import { FormSearchQuoteRequestModalTgComponent } from '../../../../shared/components/form-search-quote-request-modal-tg/form-search-quote-request-modal-tg.component'
import { JsonPipe } from '@angular/common'
import { FormSearchQuoteRequestModalTgNewComponent } from '../../../../shared/components/form-search-quote-request-modal-tg-new/form-search-quote-request-modal-tg-new.component'
import { TableListSelectPurchasesNewComponent } from '../../../../shared/components/table-list-select-purchases-new/table-list-select-purchases-new.component'

@Component({
  selector: 'purchases-quote-request-create-new',
  imports: [
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatProgressBar,
    MatPaginator,
    TableListSelectPurchasesComponent,
    MatExpansionModule,
    FormClientSearchComponent,
    FormSearchQuoteRequestTgComponent,
    FormSearchQuoteRequestModalTgComponent,
    JsonPipe,
    FormSearchQuoteRequestModalTgNewComponent,
    TableListSelectPurchasesNewComponent,
  ],
  templateUrl: './purchases-quote-request-create-new.component.html',
  styleUrl: './purchases-quote-request-create-new.component.scss',
  providers: [VehicleModelService, VehicleTypeService],
  standalone: true,
})
export class PurchasesQuoteRequestCreateNewComponent implements OnInit {
  constructor(
    private purchasesQuoteRequestService: PurchasesQuoteRequestService,
    private supplierService: SupplierService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<PurchasesQuoteRequestCreateNewComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.itemEdit = data
  }

  @Output() response = new EventEmitter()
  @ViewChild('paginatorPurchases') paginatorPurchases: MatPaginator | undefined
  @ViewChild('paginatorSupplier') paginatorSupplier: MatPaginator | undefined

  itemEdit: any = {}
  form: FormGroup = new FormGroup({})
  loading = false
  loadingSupplier = false
  loadingPurchases = false
  listType: any[] = []

  multiSelect = true

  listSelected: any[] = []
  selected: any = { id: -1, description: '' }

  page = 1
  rows = 5
  numberRows = 0
  itemsList: any[] = []

  columns: any[] = [
    {
      keyColumn: 'action',
      key: { select: true },
      description: '',
    },
    // {
    //   keyColumn: 'tgcod',
    //   key: 'codigoTg',
    //   description: 'tg cod.',
    // },
    // {
    //   keyColumn: 'event',
    //   key: 'nomeEvento',
    //   description: 'Evento',
    // },
    // {
    //   keyColumn: 'pageTariffLocation',
    //   // keyColumn: 'location_OD',
    //   key: 'origem',
    //   description: 'Trecho',
    // },
    {
      keyColumn: 'pageTariffLocationOrigin',
      // keyColumn: 'location_OD',
      key: 'origem',
      description: 'Origem',
    },
    {
      keyColumn: 'pageTariffLocationDestination',
      // keyColumn: 'location_OD',
      key: 'destino',
      description: 'Destino',
    },
    {
      keyColumn: 'servico_TS',
      key: 'tipoServico',
      description: 'Serviço',
    },
    {
      keyColumn: 'vehicle_VM',
      key: 'tipoVeiculo',
      description: 'Veículo',
    },
    {
      keyColumn: 'pageDate',
      key: 'origem',
      description: 'Data',
    },
    {
      keyColumn: 'status',
      key: 'descricaoStatus',
      description: 'Status',
    },
    {
      keyColumn: 'viewItineraries',
      key: 'descricaoStatus',
      description: '',
    },
  ]

  listSelectedSupplier: any[] = []
  selectedSupplier: any = { id: -1, description: '' }

  pageSupplier = 1
  rowsSupplier = 5
  numberRowsSupplier = 0
  itemsListSupplier: any[] = []

  columnsSupplier: any[] = [
    {
      keyColumn: 'action',
      key: { select: true },
      description: '',
    },
    // {
    //   keyColumn: 'supplierInfos',
    //   key: 'nomeFantasia',
    //   description: 'Fornecedor',
    // },
    {
      keyColumn: 'name',
      key: 'nomeFantasia',
      description: 'Nome',
    },
    {
      keyColumn: 'corporateName',
      key: 'razaoSocial',
      description: 'Razão Social',
    },
    {
      keyColumn: 'cnpj',
      key: 'cnpj',
      description: 'Cnpj',
    },
    {
      keyColumn: 'city',
      key: 'cidade',
      description: 'Cidade',
    },
    {
      keyColumn: 'state',
      key: 'estado',
      description: 'Estado',
    },
  ]

  listSearch: any = [
    {
      id: 'nomeFantasia',
      description: 'Nome Fantasia',
      type: 'string',
      visible: true,
    },
    // { id: 'cpf', description: 'CPF', type: 'string', visible: true },
    {
      id: 'razaoSocial',
      description: 'Razão Social',
      type: 'string',
      visible: true,
    },
    { id: 'cnpj', description: 'Cnpj', type: 'string', visible: true },
    {
      id: 'cidade',
      description: 'Cidade',
      type: 'string',
      visible: true,
    },
    {
      id: 'estado',
      description: 'Estado',
      type: 'string',
      visible: true,
    },
    {
      id: 'inscricaoEstadual',
      description: 'Insc. Estadual',
      type: 'string',
      visible: false,
    },
    {
      id: 'inscricaoMunicipal',
      description: 'Insc. Munucipal',
      type: 'string',
      visible: false,
    },
  ]
  inputSearch: any = { type: '', search: '' }
  searchForm: any = { search: false, model: {} }
  searchFormPurchase: any = { search: false, model: {} }

  ngOnInit(): void {
    // this.getListItems()
    this.getListSupplier()
  }

  close() {
    this.dialogRef.close()
  }

  checkModel() {
    if (this.listSelected.length > 0 && this.listSelectedSupplier.length > 0) {
      return true
    } else {
      return false
    }
  }

  createPrice() {
    this.loading = true
    const dialogRef = this.dialog.open(DialogChooseComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      data: 'Deseja enviar email para os fornecedores via sistema?',
    })
    dialogRef.afterClosed().subscribe((response) => {
      const model = this.createModel(response)
      this.purchasesQuoteRequestService
        .CreatePurchasesQuoteRequestSupplier(model)
        .subscribe({
          next: (response: any) => {
            this.snackbar.success(response.message)
            this.close()
            this.response.emit(true)
          },
          error: (err: PagedContactTypeResponse) => {
            this.snackbar.errorRequest(err)
            this.loading = false
          },
          complete: () => {
            this.loading = false
          },
        })
    })
  }

  createModel(sendEmail = false) {
    const listSupplier = this.listSelectedSupplier.map((ele: any) => {
      return ele.id
    })
    const listPurchases = this.listSelected.map((ele: any) => {
      return ele.id
    })
    return {
      fornecedores: listSupplier,
      solicitacoes: listPurchases,
      enviarEmail: sendEmail ? 'S' : 'N',
    }
  }

  selectItem(event: any, list: 'supplier' | 'purchases') {
    if (list == 'purchases') {
      if (this.multiSelect) {
        const index = this.listSelected.findIndex((ele) => ele.id == event.id)
        if (index > -1) {
          this.listSelected.splice(index, 1)
        } else {
          this.listSelected.push(event)
        }
      } else {
        if (this.selected.id == event.id) {
          this.selected = { id: -1, description: '' }
        } else {
          this.selected = event
        }
      }
    } else if (list == 'supplier') {
      if (this.multiSelect) {
        const index = this.listSelectedSupplier.findIndex(
          (ele) => ele.id == event.id,
        )
        if (index > -1) {
          this.listSelectedSupplier.splice(index, 1)
        } else {
          this.listSelectedSupplier.push(event)
        }
      } else {
        if (this.selectedSupplier.id == event.id) {
          this.selectedSupplier = { id: -1, description: '' }
        } else {
          this.selectedSupplier = event
        }
      }
    }
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push({
          ...item,
          tipoServico: item.descricaoTipoServico,
          servico: item.descricaoServico,
          tipoVeiculo: item.descricaoTipoVeiculo,
          tipoMotorista: item.descricaoTipoMotorista,
        })
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  treatResponseSupplier(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push({
          ...item,
          tipoServico: item.descricaoTipoServico,
          servico: item.descricaoServico,
          tipoVeiculo: item.descricaoTipoVeiculo,
          tipoMotorista: item.descricaoTipoMotorista,
        })
      }
    }
    this.itemsListSupplier = list
    this.numberRowsSupplier = response.totalItens
  }

  // pageChanged($event: any) {
  //   this.page = $event.pageIndex + 1
  //   // this.rows = $event.pageSize
  //   this.uploadList()
  // }

  pageChanged(event: PageEvent, list: 'supplier' | 'purchases') {
    if (list == 'purchases') {
      this.page = event.pageIndex + 1
      this.rows = event.pageSize
    } else if (list == 'supplier') {
      this.pageSupplier = event.pageIndex + 1
      this.rowsSupplier = event.pageSize
    }
    this.uploadList('', list)
  }

  uploadList(
    type = '',
    list: 'supplier' | 'purchases',
    search: 'new' | '' = '',
  ) {
    if (list == 'purchases') {
      this.getListItems()
    } else if (list == 'supplier') {
      if (search == 'new') {
        this.searchForm = { search: false, model: {} }
      }
      if (this.searchForm.search) {
        this.searchListSupplier()
      } else {
        this.getListSupplier()
      }
    }
    // if (type == 'new') {
    //   this.searchForm = { search: false, model: {} }
    // }
    // if (this.searchForm.search) {
    //   this.searchAddress()
    // } else {
    //   this.getListItems()
    // }
  }

  getListItems() {
    this.loadingPurchases = true
    // this.purchasesQuoteRequestService
    //   .listPagedPurchasesQuoteRequestOpen(this.page, this.rows)
    //   .subscribe({
    //     next: (response: any) => {
    //       this.treatResponse(response)
    //     },
    //     error: (err: PagedContactTypeResponse) => {},
    //     complete: () => {
    //       this.loadingPurchases = false
    //     },
    //   })
    this.purchasesQuoteRequestService
      .searchPagedPurchasesQuoteRequestFromPurchase(
        this.page,
        this.rows,
        this.searchFormPurchase.model,
      )
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loadingPurchases = false
        },
      })
  }

  getListSupplier() {
    this.loadingSupplier = true
    this.supplierService
      .searchPagedSupplierLegal(this.pageSupplier, this.rowsSupplier, {
        inscMunicipal: '',
        inscEstadual: '',
        ativo: 'S',
        nomeFantasia: '',
        razaoSocial: '',
        cnpj: '',
        inscricaoEstadual: '',
        cidade: '',
        estado: '',
        inscricaoMunicipal: '',
      })
      .subscribe({
        next: (response: any) => {
          this.treatResponseSupplier(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loadingSupplier = false
        },
      })
  }

  searchListSupplier() {
    this.loadingSupplier = true
    this.supplierService
      .searchPagedSupplierLegal(
        this.pageSupplier,
        this.rowsSupplier,
        this.searchForm.model,
      )
      // .searchPagedSupplierLegal(this.page, this.rows, this.searchForm)
      .subscribe({
        next: (response: any) => {
          this.treatResponseSupplier(response)
        },
        error: (err: PagedContactTypeResponse) => {
          this.loadingSupplier = false
        },
        complete: () => {
          this.loadingSupplier = false
        },
      })
  }

  viewItinerariesItem(item: any) {
    const dialogRef = this.dialog.open(
      ModalPurchasesRequestItinerariesComponent,
      {
        enterAnimationDuration: '100ms',
        exitAnimationDuration: '100ms',
        width: '1000px',
        maxWidth: '1000px',
        maxHeight: '620px',
        data: { item: item },
      },
    )
  }

  search(event: any, type: 'supplier' | 'purchases') {
    if (type == 'supplier') {
      if (event.search) {
        this.searchForm = {
          search: true,
          model: this.createModelSearch(event.data),
        }
      }
      this.pageSupplier = 1
    } else if (type == 'purchases') {
      if (event) {
        this.searchFormPurchase = this.createModelSearchRequest(event)
      }
      this.page = 1
    }
    // this.uploadList(!event.search ? 'new' : '')
    this.uploadList('', type, !event.search ? 'new' : '')
  }

  createModelSearchRequest(element: any) {
    const model = {
      model: {
        consultorComercial: element.model.consultorComercial,
        dataFinal: element.model.dataFinal,
        dataInicio: element.model.dataInicio,
        descricaoServico: element.model.descricaoServico,
        descricaoTipoMotorista: element.model.descricaoTipoMotorista,
        descricaoTipoServico: element.model.descricaoTipoServico,
        descricaoTipoVeiculo: element.model.descricaoTipoVeiculo,
        destinoCidade: element.model.destinoCidade,
        destinoEstado: element.model.destinoEstado,
        eventoNome: '',
        // eventoNome: this.itemEdit.nomeEvento,
        nomeCliente: element.model.nomeCliente,
        nomeConsultor: element.model.nomeConsultor,
        nomeSubCliente: element.model.nomeSubCliente,
        origemCidade: element.model.origemCidade,
        origemEstado: element.model.origemEstado,
        statusId: element.model.statusId,
        tg: this.itemEdit.tg,
      },
      search: element.search,
    }
    return model
  }

  createModelSearch(element: any) {
    const model: any = {
      inscMunicipal: '',
      inscEstadual: '',
      ativo: 'S',
    }

    for (let i = 0; i < this.listSearch.length; i++) {
      const item = this.listSearch[i]
      model[item.id] =
        item.id == element.type
          ? element.search
          : responseDefaultForm(item.type)
    }
    return model
  }

  newSupplier() {
    const dialogRef = this.dialog.open(SupplierCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
    })
    dialogRef.componentInstance.responseCreate.subscribe((response) => {
      this.uploadList('', 'supplier', 'new')
    })
  }
}
